import { PaletteOptions } from '@mui/material/styles';
import { FontSize } from '@store/types/UserStoreSlice.type';

import { getTypographyVariants } from '@theme/styleOverrides/typography';

const MuiSelect = ({ palette, fontSize }: { palette: PaletteOptions; fontSize: FontSize }) => ({
  styleOverrides: {
    root: {
      ...getTypographyVariants(fontSize).bodySmall,

      '& .MuiSelect-outlined': {
        padding: '8px 12px 8px 12px',
        color: palette.text?.main,
      },
    },
  },
});

export { MuiSelect };
